(ns frontend.test-nev-v3.view
  (:require
   [re-frame.core :as rf]
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [ui.state.session.sub :as session-sub]
   [frontend.view.not-found :as not-found]
   [frontend.test-nev-v3.event :as event]
   [ui.view.nev.event :as nev-event]
   [frontend.view.syncing-data :as syncing-data]
   [common.sync-progress :as sync-progress]
   [ui.view.nev.view :as nev-view]
   [ui.editors.card.view :as card-editor]))

(defn company-view
  [{:keys [company-id]}]
  (rf/dispatch-sync [::event/init])
  (rf/dispatch-sync [::nev-event/open-view {:view-id "default-company-view"
                                            :entity-id company-id}])
  (fn [_]
    [:div
           ;; TODO fix height hack
     {:class "grow max-h-[calc(100vh-52px)] overflow-hidden"}
     [nev-view/view]
     [card-editor/view]]))

(defmethod routing/render-view :company-nev-v3
  [{:keys [route-params] :as _args}]
  (let [company-id (-> route-params
                       :id
                       js/parseInt)]
    (if-not (session/nev-v3?)
      [not-found/not-found-view]
      [syncing-data/wait-until-sync-progress sync-progress/BASE
       [default-page-layout/view
        ^{:key (str "company-nev3-" company-id)}
        [company-view {:company-id company-id}]]])))
